export enum ORGANISATION_FEATURE_FLAGS {
  USE_V2_AGGREGATES = 'USE_V2_AGGREGATES'
}